<template>
    <div class="icon icon-close" :class="[size ? 'icon--size-' + size : '']"></div>
</template>

<script>
export default {
    props: {
        size: { type: String, default: "default" },
    },
    components: {},
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.icon-close {
    position: relative;
    transform: rotate(45deg);
    transition: 0.25s ease-out;
    &::before,
    &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 2px;
        display: block;
        background-color: currentColor;
    }
    &::after {
        transform: translate(-50%, -50%) rotate(90deg);
    }
    &.icon--size {
        &-xx-small {
            width: 16px;
            height: 16px;
            &::before,
            &::after{
                height: 1px;
            }            
        }
        &-x-small {
            width: 18px;
            height: 18px;
            &::before,
            &::after{
                height: 1px;
            }            
        }
        &-small {
            width: 24px;
            height: 24px;
            &::before,
            &::after{
                height: 1px;
            }            
        }
        &-default {
            width: 26px;
            height: 26px;
        }
        &-large {
            width: 54px;
            height: 54px;
        }
        &-x-large {
            width: 58px;
            height: 58px;
        }
        &-xx-large {
            width: 64px;
            height: 64px;
        }
    }
}
@media (min-width:576px){
}
@media (min-width:768px){
    .icon-close {
        &.icon--size {
            &-default {
                width: 38px;
                height: 38px;
            }
        }
    }
}
@media (min-width:1024px){
}
@media (min-width:1200px){
}

</style>
